import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, AlertController, ToastController, Platform } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase/app';
import * as moment from 'moment';
import { EmailProvider } from '../../providers/email/email';
import { DateTimeAdapter } from 'ng-pick-datetime';

@IonicPage()
@Component({
  selector: 'page-session-add',
  templateUrl: 'session-add.html',
})
export class SessionAddPage {

  selectedFiles1: FileList;
  file1;
  Files: boolean = false;
  arrayFiles: any[] = [];
  arrayResult: any[] = [];
  myForm: FormGroup;
  loading: Loading;
  idParent: string;
  coachId: string;
  nameParent: string;
  inputFile: any[] = [""];
  mensaje: any;
  public min = moment().format();
  public min2 = new Date();
  public isMobile: boolean;

  constructor(platform: Platform, dateTimeAdapter: DateTimeAdapter<any>, public navCtrl: NavController, public navParams: NavParams, public formBuilder: FormBuilder, public afAuth: AngularFireAuth, public alertCtrl: AlertController, public loadingCtrl: LoadingController, private afs: AngularFirestore, public toastCtrl: ToastController, public emailProvider: EmailProvider) {
    dateTimeAdapter.setLocale('es-ES'); // change locale to spanish
    this.idParent = navParams.get("idParent");
    this.nameParent = navParams.get("nameParent");
    this.coachId = navParams.get("coachId");
    this.myForm = this.formBuilder.group({
      description: ['', Validators.required],
      title: ['', Validators.required],
      sessionDate: ['', Validators.required]
    });
    platform.ready().then(() => {
      if (platform.is('mobile')) {
        this.isMobile = true;
      } else {
        ////console.log('browser');
        this.isMobile = false;
      }
    });
  }

  ionViewDidEnter() {
  }

  selectFile(event: any, id: number) {
    if (event && event.target && event.target.value) {
      this.arrayFiles.push({ "file": event.target.files[0] });
    }
  }

  deleteFromArray(index: number) {
    this.arrayFiles.splice(index, 1);
  }

  addStorage() {
    this.presentLoadingCustom();
    if (this.arrayFiles.length > 0) {
      this.uploadFileSStorage(this.arrayFiles).then(data => {
        this.arrayResult = data;
        this.addUserToDb();
      });
    } else {
      this.addUserToDb();
    }
  }

  addUserToDb() {

    let date;
    if (this.isMobile) {
      let dif = (moment(this.myForm.value.sessionDate).utcOffset() / 60) * -1;
      date = moment(this.myForm.value.sessionDate).add(dif, "hours");
    } else {
      date = this.myForm.value.sessionDate;
    }

    let data = {
      creationDate: new Date(),
      description: this.myForm.value.description,
      files: this.arrayResult,
      idAlumno: this.idParent,
      idCoach: this.coachId,
      title: this.myForm.value.title,
      sessionDate: new Date(date),
      tasks: []
    }
    this.currentUsers(data);
    this.afs.collection('Sessions').add(data).then(res => {
      this.loading.dismiss();
      this.presentToast("Sesión agregada correctamente");
      this.navCtrl.pop();
    }).catch(error => {
      this.loading.dismiss();
      this.presentToast(error);
    });
  }

  sendMail(arreglo: any[], data: any) {
    let date = new Date(data.sessionDate);
    let mensaje = `
      <!doctype html>
      <html lang='es'>      
      <head>
      <meta charset='utf-8'>
      <title>Sesion programada Coaching personal</title>
      </head>      
      <body>
      <h1>Se ha agendado un nueva sesión:</h1>
      <p><strong>Coach: </strong>`+ arreglo[0].name + `</p>
      <p><strong>Coachee: </strong>`+ arreglo[1].name + `</p>
      <hr>
      <h2>`+ data.title + `</h2>
      <h3>`+ date + `</h3>
      <p>`+ data.description + `</p>
      </body>      
      </html>`;

    const body = {
      "subject": "Sesion programada Coaching personal",
      "template": "coaching",
      "params": [
        { "name": mensaje }
      ],
      "from": {
        "name": "Retirement Advising",
        "email": "no-reply@retirement.com"
      },
      "to": arreglo
    }
    ////console.log(body);
    this.emailProvider.sendEmail(body);
  }

  currentUsers(datos: any) {
    let P1: Promise<any>;
    let P2: Promise<any>;
    P1 = this.afs.doc("Users/" + this.idParent).ref.get();
    P2 = this.afs.doc("Users/" + this.coachId).ref.get();
    let array: any[] = [];
    Promise.all([P1, P2]).then((data) => {
      array.push({ email: data[0].data().email, name: data[0].data().name });
      array.push({ email: data[1].data().email, name: data[1].data().name });
      this.sendMail(array, datos);
    }).catch(error => {
      ////console.log(error);
    });
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  presentConfirm() {
    let alert = this.alertCtrl.create({
      title: 'Confirm purchase',
      message: 'Do you want to buy this book?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            ////console.log('Cancel clicked');
          }
        },
        {
          text: 'Buy',
          handler: () => {
            ////console.log('Buy clicked');
          }
        }
      ]
    });
    alert.present();
  }

  async uploadFileSStorage(files: any[]): Promise<any[]> {
    let filesRet: any[] = [];
    for (let x: number = 0; x < files.length; x++) {
      var storageRef = firebase.storage().ref();
      var fileRef = storageRef.child('files/' + new Date().getTime() + files[x].file.name);
      await fileRef.put(files[x].file).then((res) => {
        filesRet.push({ "downloadURL": res.downloadURL, "fullPath": res.metadata.fullPath, "name": files[x].file.name });
      });
    }
    return filesRet;
  }

  cancel() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/session-add/session-add.ts